import React, { useState } from 'react';
import { activePb } from '../../lib/pb';
import { useData } from '../../data/DataProvider';
import { useToast } from '../../shared/components/ToastProvider';
import FileDropzone from '../../shared/components/FileDropzone';
import AddressAutocomplete from '../../shared/components/AddressAutocomplete';

// Business profile — the tenant's name/address/contact + logo.
// The address stays a SINGLE line (invoices print it as one block, and
// tenants.address is not structured by schema §4), so the autocomplete
// stores the formatted label rather than structured parts. Clients and
// jobs get full structured addresses (see ClientForm).
export default function BusinessProfile() {
  const { data, updateCollection } = useData();
  const { notify } = useToast();
  const [form, setForm] = useState(data.settings.business);
  const [logoFiles, setLogoFiles] = useState([]);

  const save = async (event) => {
    event.preventDefault();
    try {
      await updateCollection('settings', { ...data.settings, business: form });
      // Logo is a file field — PATCH it directly with FormData.
      if (logoFiles.length) {
        const formData = new FormData();
        logoFiles.forEach((file) => formData.append('logo', file));
        await activePb().collection('tenants').update(data.tenant.id, formData);
        setLogoFiles([]);
      }
      notify('Business profile saved');
    } catch (err) {
      notify(err.message || 'Failed to save profile', 'error');
    }
  };

  return (
    <section className="panel settings-form">
      <h3>Business profile</h3>
      <form onSubmit={save}>
        <label>Business name<input value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} /></label>
        <label>Address
          <AddressAutocomplete
            initial={form.address || ''}
            onSelect={(place) => setForm({ ...form, address: place.label })}
            placeholder="Start typing your business address…"
          />
        </label>
        <label>Contact email<input value={form.contact_email} onChange={(event) => setForm({ ...form, contact_email: event.target.value })} /></label>
        <label>Contact phone<input value={form.contact_phone} onChange={(event) => setForm({ ...form, contact_phone: event.target.value })} /></label>
        <label>Logo
          <FileDropzone
            onFiles={setLogoFiles}
            accept="image/png,image/jpeg,image/svg+xml,image/webp"
            hint="PNG / JPEG / SVG / WebP, up to 5 MB"
            multiple={false}
          />
        </label>
        {logoFiles.length ? <p className="field-hint">{logoFiles[0].name} ready to upload</p> : null}
        <button className="primary-button">Save profile</button>
      </form>
    </section>
  );
}
